module.exports = __webpack_public_path__ + "static/media/auth-image.32201a11.png";